import React, { useState, useEffect } from "react";
import { Form, Button, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { map } from "lodash";

export function AddEditCursos(props) {
  const [refetch] = useState(false);
  const { auth } = useAuth();
  const { onRefetch, curso } = props;
  const [grupos, setGrupos] = useState(null);
  const [materias, setMaterias] = useState(null);
  const [periodos, setPeriodos] = useState(null);
  const [gruposFormato, setGruposFormato] = useState([]);
  const [materiasFormato, setMateriasFormato] = useState([]);
  const [periodoFormato, setPeriodoFormato] = useState([]);

  async function getPeriodosApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/periodo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      let periodosOrdenados = response.data;
      // Ordenar los períodos por fecha de inicio de manera descendente
      periodosOrdenados.sort(
        (a, b) => new Date(b.fecha_inicio) - new Date(a.fecha_inicio)
      );
      setPeriodos(periodosOrdenados);
      return periodosOrdenados;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getPeriodosApi();
    // eslint-disable-next-line
  }, [refetch]);

  useEffect(() => {
    // Solo setear periodoFormato si periodos tiene datos
    if (periodos && periodos.length > 0) {
      setPeriodoFormato(formatoDropdownPeriodo(periodos));
    }
  }, [periodos]);

  async function getMateriasApi(tipoSemestre) {
    try {
      const semestresArray = tipoSemestre.split(",");
      const response = await axios.get(`${BASE_API}/api/materia/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const materiasFiltradas = response.data.filter((materia) =>
        semestresArray.includes(materia.semestre)
      );
      setMaterias(materiasFiltradas);
      return materiasFiltradas;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    setMateriasFormato(formatoDropdownMateria(materias));
  }, [materias]);

  async function getGruposApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/grupo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setGrupos(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getGruposApi();
    // eslint-disable-next-line
  }, [refetch]);

  useEffect(() => {
    setGruposFormato(formatoDropdownGrupo(grupos));
  }, [grupos]);

  function formatoDropdownGrupo(data) {
    return map(data, (item) => ({
      key: item.id_grupo,
      text: item.numero_grupo,
      value: item.id_grupo,
    }));
  }

  function formatoDropdownMateria(data) {
    return map(data, (item) => ({
      key: item.id,
      text: `${item.nombre_materia} - ${item.semestre} SEMESTRE`,
      value: item.id,
    }));
  }

  const formatPeriodo = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);;
  };

  function formatoDropdownPeriodo(informacionCicloEscolar) {
    return map(informacionCicloEscolar, (item) => ({
      key: item.id_periodo,
      text: `${formatPeriodo(item.fecha_inicio)} - ${formatPeriodo(
        item.fecha_fin
      )} - Semestre: ${
        item.tipo_semestre === "A" ? "A (semestre impar)" : "B (semestre par)"
      }`,
      value: item.id_periodo,
    }));
  }

  const semestres = {
    I: ["101", "102", "103"],
    II: ["101", "102", "103"],
    III: ["201", "202", "203"],
    IV: ["201", "202", "203"],
    V: ["301", "302", "303"],
    VI: ["301", "302", "303"],
    VII: ["401", "402", "403"],
    VIII: ["401", "402", "403"],
  };

  const createCursosForSemester = async (semestre, formValues) => {
    const gruposToCreate = semestres[semestre.toUpperCase()];
    let cursosExitosos = [];
    let cursosFallidos = [];

    // Crear cursos para cada grupo
    await Promise.all(
      gruposToCreate.map(async (grupoNumero) => {
        const numeroGrupo = parseInt(grupoNumero, 10);
        const grupo = grupos.find((g) => g.numero_grupo === numeroGrupo);
        if (grupo) {
          const data = {
            periodo: formValues.periodo,
            materia: formValues.materia,
            grupo: grupo.id_grupo,
          };
          if (curso) {
            await updateCurso(curso.id, data);
          } else {
            const result = await createCursoApi(data, auth.token);
            if (result) {
              cursosExitosos.push(numeroGrupo);
            } else {
              cursosFallidos.push(numeroGrupo);
            }
          }
        }
      })
    );

    if (cursosExitosos.length > 0) {
      toast.success(
        `Curso creado exitosamente para los grupos: ${cursosExitosos.join(
          ", "
        )}`
      );
    }

    if (cursosFallidos.length > 0) {
      toast.error(
        `El curso para los grupos ${cursosFallidos.join(
          ", "
        )} ya existe para este periodo.`
      );
    }
  };

  const updateCurso = async (id, data) => {
    try {
      await updateCursoApi(id, data, auth.token);
    } catch (error) {
      throw error;
    }
  };

  async function createCursoApi(data, token) {
    try {
      const url = `${BASE_API}/api/curso/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      console.log(data);
      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Mostrar mensaje de error específico para cursos ya existentes, pero continuar la ejecución
        return null; // Retornar null en caso de error 400 para indicar que ya existe
      }
      throw error; // Lanzar otros errores para manejo genérico
    }
  }

  async function updateCursoApi(id, data, token) {
    try {
      const url = `${BASE_API}/api/curso/${id}/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.patch(url, data, { headers });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        toast.error("Ya existe este curso para este periodo");
      }
      throw error;
    }
  }

  const formik = useFormik({
    initialValues: initialValues(curso),
    validationSchema: Yup.object(curso ? updateSquema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValues, { resetForm }) => {
      try {
        if (curso) {
          await updateCurso(curso.id, formValues);
        } else {
          const materiaSeleccionada = materias.find(
            (materia) => materia.id === formValues.materia
          );
          const semestreMateria = materiaSeleccionada?.semestre;
          if (semestreMateria) {
            await createCursosForSemester(semestreMateria, formValues);
          }
        }
        // Eliminar la llamada a toast.success
        resetForm();
        onRefetch();
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    if (periodos && periodos.length > 0) {
      const periodoSeleccionado = periodos.find(
        (periodo) => periodo.id_periodo === formik.values.periodo
      );
      if (periodoSeleccionado) {
        const tipoSemestre =
          periodoSeleccionado.tipo_semestre === "B"
            ? "II,IV,VI,VIII"
            : "I,III,V,VII";
        getMateriasApi(tipoSemestre);
        formik.setFieldValue("materia", "");
      }
    }
  }, [formik.values.periodo, periodos]);

  return (
    <>
      <div className="divcampo">
        <label className="campR">
          Campo requerido <span className="astedisco">*</span>
        </label>
      </div>

      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <label>
          Selección del período{" "}
          <span className="astedisco">*</span>
        </label>
        <Dropdown
          placeholder="Seleccione un período"
          fluid
          selection
          search
          options={periodoFormato}
          value={formik.values.periodo}
          error={formik.errors.periodo}
          onChange={(_, datos) => {
            formik.setFieldValue("periodo", datos.value);
          }}
        />
        <label>
          Selección de la materia{" "}
          <span className="astedisco">*</span>
        </label>
        <Dropdown
          placeholder="Seleccione una materia"
          fluid
          selection
          search
          options={materiasFormato}
          value={formik.values.materia}
          error={formik.errors.materia}
          onChange={(_, datos) => {
            formik.setFieldValue("materia", datos.value);
          }}
        />
        <Button
          type="submit"
          content={curso ? "Actualizar" : "Crear"}
          style={{ backgroundColor: "#008e86", color: "white" }}
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function initialValues(datosCurso) {
  return {
    periodo: datosCurso?.periodo || "",
    materia: datosCurso?.materia || "",
    grupo: datosCurso?.grupo || "",
  };
}

function newSchema() {
  return {
    periodo: Yup.string().required(true),
    materia: Yup.string().required(true),
  };
}
function updateSquema() {
  return {
    periodo: Yup.string().required(true),
    materia: Yup.string().required(true),
  };
}
